import { compose, find, findLast, head, last, prop } from 'ramda'
import React from 'react'
import { COLORS } from '@btime/constants'

import { useLevelsSettingsForm, useLevelsSettingsFormActions } from './_form/LevelSettingsFormHandler'
import FlexGrid, { FlexCol } from '../../../components/structure/FlexGrid'
import Icon from '../../../components/shapes/Icon'
import Input from '../../../components/form/Input'
import Link from '../../../components/actions/Link'
import Separator from '../../../components/helpers/Separator'

const LevelsSettings = () => {
  const { levels } = useLevelsSettingsForm()
  const { handleChange } = useLevelsSettingsFormActions()

  const controlledLevels = levels.filter(
    level => level.id !== prop('id', last(levels)) && level.id !== prop('id', head(levels))
  )

  const idToDisable = compose(
    prop('id'),
    findLast(item => item.enabled)
  )(controlledLevels)
  const idToEnable = compose(
    prop('id'),
    find(item => !item.enabled)
  )(controlledLevels)

  return (
    <div>
      <Separator weight={2} />
      {levels.map(level => (
        <FlexGrid justify="flex-start" gutter={0.4} key={level.id}>
          <FlexCol flex={15}>
            <Input value={level.name} xsmall onChange={handleChange(level.id, 'name')} disabled={!level.enabled} />
          </FlexCol>
          <FlexCol flex={1}>
            {(idToEnable === level.id || idToDisable === level.id) && (
              <Link block onClick={() => handleChange(level.id, 'enabled', !level.enabled)}>
                <Icon
                  name={level.enabled ? 'BsXSquare' : 'BsPlusSquareFill'}
                  color={level.enabled ? COLORS.red : COLORS.dark3}
                />
              </Link>
            )}
          </FlexCol>
        </FlexGrid>
      ))}
    </div>
  )
}

export default LevelsSettings
